var map = {
	"./1 Rati Chakravyuh.jpg": 2161,
	"./2 Rati Chakravyuh.jpg": 7082,
	"./5 Rati Chakravyuh.jpg": 9797,
	"./6 Rati Chakravyuh.jpg": 9470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5564;